import { ChevronLeft, ChevronRight } from 'lucide-react';

interface ScrollButtonProps {
  direction: 'left' | 'right';
  onClick: () => void;
  className?: string;
}

export const ScrollButton = ({
  direction,
  onClick,
  className,
}: ScrollButtonProps) => (
  <button
    onClick={onClick}
    className={`absolute top-1/2 -translate-y-1/2 z-10
              bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm
              p-2 rounded-full shadow-lg
              opacity-0 group-hover:opacity-100
              transition-opacity duration-200
              disabled:opacity-0
              hover:bg-white dark:hover:bg-gray-800
              ${className}`}
    style={{ [direction]: 0 }}
  >
    {direction === 'left' ? (
      <ChevronLeft className="w-6 h-6 text-gray-700 dark:text-gray-300" />
    ) : (
      <ChevronRight className="w-6 h-6 text-gray-700 dark:text-gray-300" />
    )}
  </button>
);
